<template>
    <div class="page">
        {{ date }}
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ creditor.creditor_name }}
            <br />
            {{ creditor.address_line }}
            <br />
            {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
        </p>
        <br/>
        <p style="text-align: center;margin-bottom: 0;">
            Original Creditor:
            <br/>
            <template v-if="lodash.isEmpty(repossession.oc_name)">
                [<span style="background-color: #fbff1d;">Name</span>]
            </template>
            <template v-else>
                {{ repossession.oc_name }}
            </template>
            <br/>
            <template v-if="lodash.isEmpty(repossession.oc_ddress)">
                [<span style="background-color: #fbff1d;">Address</span>]
            </template>
            <template v-else>
                {{ repossession.oc_ddress }}
            </template>
            <br/>
            <template v-if="lodash.isEmpty(repossession.oc_city)">
                [<span style="background-color: #fbff1d;">City</span>],
            </template>
            <template v-else>
                {{ repossession.oc_city }},
            </template>
            <template v-if="lodash.isEmpty(repossession.oc_state)">
                [<span style="background-color: #fbff1d;">State</span>],
            </template>
            <template v-else>
                {{ repossession.oc_state }},
            </template>
            <template v-if="lodash.isEmpty(repossession.oc_zip_code)">
                [<span style="background-color: #fbff1d;">zipCode</span>],
            </template>
            <template v-else>
                {{ repossession.oc_zip_code }},
            </template>
            <br/>
        </p>
        <br/>
        <p style="text-align: center;margin-bottom: 0;">
            Collection Agency:
            <br/>
            <template v-if="lodash.isEmpty(repossession.collection_agency)">
                [<span style="background-color: #fbff1d;">Name</span>]
            </template>
            <template v-else>
                {{ repossession.collection_agency }}
            </template>
            <br/>
            <template v-if="lodash.isEmpty(repossession.Address)">
                [<span style="background-color: #fbff1d;">Address</span>]
            </template>
            <template v-else>
                {{ repossession.Address }}
            </template>
            <br/>
            <template v-if="lodash.isEmpty(repossession.City)">
                [<span style="background-color: #fbff1d;">City</span>],
            </template>
            <template v-else>
                {{ repossession.City }},
            </template>
            <template v-if="lodash.isEmpty(repossession.state)">
                [<span style="background-color: #fbff1d;">State</span>],
            </template>
            <template v-else>
                {{ repossession.state }},
            </template>
            <template v-if="lodash.isEmpty(repossession.zip_code)">
                [<span style="background-color: #fbff1d;">zipCode</span>],
            </template>
            <template v-else>
                {{ repossession.zip_code }},
            </template>
            <br/>
        </p>
        <p style="text-align: center;margin-bottom: 0;">
            Car Dealer:
            <br/>
            <template v-if="lodash.isEmpty(repossession.CarDealer)">
                [<span style="background-color: #fbff1d;">Name</span>]
            </template>
            <template v-else>
                {{ repossession.CarDealer }}
            </template>
            <br/>
            <template v-if="lodash.isEmpty(repossession.CarDealerAddress)">
                [<span style="background-color: #fbff1d;">Address</span>]
            </template>
            <template v-else>
                {{ repossession.CarDealerAddress }}
            </template>
            <br/>
            <template v-if="lodash.isEmpty(repossession.CarDealerCity)">
                [<span style="background-color: #fbff1d;">City</span>],
            </template>
            <template v-else>
                {{ repossession.CarDealerCity }},
            </template>
            <template v-if="lodash.isEmpty(repossession.CarDealerstate)">
                [<span style="background-color: #fbff1d;">State</span>],
            </template>
            <template v-else>
                {{ repossession.CarDealerstate }},
            </template>
            <template v-if="lodash.isEmpty(repossession.ZipCode)">
                [<span style="background-color: #fbff1d;">zipCode</span>],
            </template>
            <template v-else>
                {{ repossession.ZipCode }},
            </template>
            <br/>
        </p>
        <p style="text-align: center;margin-bottom: 0;">
            RE:
            <br/>
            <template v-if="lodash.isEmpty(repossession.CarMake)">
                [<span style="background-color: #fbff1d;">Car Make, </span>
            </template>
            <template v-else>
                {{ repossession.CarMake }}
            </template>
            <br/>
            <template v-if="lodash.isEmpty(repossession.CarModel)">
                <span style="background-color: #fbff1d;">Car Model</span>]
            </template>
            <template v-else>
                {{ repossession.CarModel }}
            </template>

            <br/>
        </p>
        <p class="letter-content">
            I am writing to you regarding the repossession of the above mentioned car. The repo took place
            on {{ repossession.repoDate != null ? moment(repossession.repoDate).format('LL'):'(Insert Date)' }} by {{ repossession.dateSent != null ? moment(repossession.dateSent).format('LL'):'(Insert Date)' }} and was resold on or about {{ repossession.resoldDate != null ? moment(repossession.resoldDate).format('LL'):'(Insert Date)' }}.
        </p>
        <p class="letter-content">
            I am not refusing to pay the debt, but I am disputing it.
            A deficiency cannot be claimed unless the correct notices were given in a proper and timely manner.
        </p>
        <p class="letter-content">
            Also, the law states that there must be sufficient redemption and cure time limits before a repossession may occur.
        </p>
        <p class="letter-content">
            I am requesting copies of all dated notices sent to me and I am also requesting a copy of the bill of resale for my records.
        </p>
        <p class="letter-content">
            If for some reason you are unable to respond to my requests within 15 days from receipt of this letter, I will assume that this
            deficiency is indeed voided. I will also continue to check my credit report.
        </p>
        <p class="letter-content">
            If there continues to be any collection activities or damaging credit reporting, that will be a direct violation of the Fair
            Debt Collecting Practices Act and I will not hesitate to file a complaint with the Federal Trade Commission.
        </p>
        <p>
            Regards,
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            repossession: {
                type: [Array, Object]
            },
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                lodash: lodash,
                moment:moment
            };
        }
    };
</script>
